import React from 'react';
import PropTypes from "prop-types";
import { TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';

export const TableHeadLineasInsumos = (props) => {

    const {
      order,
      orderBy,
      onRequestSort,
    } = props;
    
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    const headCells = [
      { align: "left", enabledSort: false, visible: true },
      { align: "left", enabledSort: false, visible: true },
      { id: "nroLinea", align: "left", label: "N° Línea", enabledSort: false, visible: true },
      { id: "carnet", disablePadding: true, label: "Carnet / Afiliado", align: "center", enabledSort: true, minWidth: 200, visible: true },
      // { id: "codMat", disablePadding: false, label: "Cod. Material", align: "left", enabledSort: true },
      { id: "desMat", disablePadding: false, label: "Descripcion Material", align: "left", enabledSort: true, visible: true },
      { align: "left", enabledSort: false, visible: true },
      { id: "fechaPrestacion", disablePadding: false, label: "Fecha Realización", align: "left", enabledSort: true, visible: true },
      { id: "cantidad", disablePadding: false, label: "Cantidad", align: "left", enabledSort: false, visible: true },
      { id: "importe", disablePadding: false, label: "Importe Unit", align: "left", enabledSort: true, visible: true },
      // { id: "fechaInternacionDesde", disablePadding: false, label: "Fecha Internación Desde", align: "left", enabledSort: false },
      // { id: "fechaInternacionHasta", disablePadding: false, label: "Fecha Internación Hasta", align: "left", enabledSort: false },
      { id: "nroValidacion", disablePadding: false, label: "Nro Validación", align: "left", enabledSort: true, visible: props.comprobanteSeleccionado.comprobanteContrato.efectorFacturacion.validaPortalPrestador },
      { id: "idSolicitud", disablePadding: false, label: "IdSolicitud", align: "left", enabledSort: true, visible: props.comprobanteSeleccionado.comprobanteContrato.efectorFacturacion.validaAutorizacion },
      { id: "subtotal", disablePadding: false, label: "Subtotal", align: "left", enabledSort: false, visible: true },
      { id: "importeDebito", disablePadding: false, label: "Debito", align: "center", enabledSort: false, visible: true },
      { id: "total", disablePadding: false, label: "Total a Pagar", align: "center", enabledSort: false, visible: true },
      { align: "left", enabledSort: false }
    ];
  
    return (
      <TableHead>
        <TableRow>
          {headCells.filter(s => s.visible).map((headCell) => (
            <TableCell
              key={headCell.id}
              align={headCell.align}
              padding={headCell.disablePadding ? "none" : "default"}
              sortDirection={orderBy === headCell.id ? order : false}
              style={{minWidth: headCell.minWidth}}
            >
              {headCell.enabledSort
                ?
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : "asc"}
                    onClick={createSortHandler(headCell.id)}
                  >
                    {headCell.label}
                  </TableSortLabel>
                :
                  <>{headCell.label}</>
              }
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
  
  TableHeadLineasInsumos.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
  };